<template>
    <div
        class="WInputSelect"
        :class="{ error }"
    >
        <WInput
            v-model="input"
            :type="type"
            :error="error"
            :placeholder="placeholder"
            name="input"
            :disabled="disabled"
            v-on="listeners"
        />
        <WSelect
            v-model="option"
            :options="options"
            name="option"
            :disabled="disabled"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { generateIdMixin } from '@/mixins'

const TYPES = [
    'text',
    'password',
    'email',
    'number',
    'url',
    'tel',
]

export default {
    name: 'WInputSelect',
    mixins: [generateIdMixin],
    props: {
        name: VueTypes.string.isRequired,
        type: VueTypes.oneOf(TYPES).isRequired,
        error: VueTypes.string.def(''),
        options: VueTypes.array.isRequired,
        placeholder: VueTypes.string.def(''),
        disabled: VueTypes.bool.def(false),
        preselected: VueTypes.bool.def(false),
        value: VueTypes.any,
        listeners: VueTypes.any,
    },
    data () {
        return {
            internalValue: {},
            input: '',
            option: {},
        }
    },
    watch: {
        input (input) {
            this.internalValue = { ...this.internalValue, input }
            this.notify()
        },
        option (selected) {
            if (selected) {
                const { key: option } = selected
                if (option) {
                    this.internalValue = { ...this.internalValue, option }
                    this.notify()
                }
            }
        },
        value (newValue) {
            const { input, value } = newValue
            if (input) this.input = input
            if (value) {
                this.option = {
                    key: value,
                    label: value,
                }
            }
        },
    },
    methods: {
        notify () {
            this.$emit('onUpdate', this.internalValue)
        },
    },
}
</script>

<style scoped lang="scss">
.WSelect {
    &::v-deep .multiselect__select {
        top: 2px;
        padding: 0;
    }
    &::v-deep .multiselect__tags {
        display: flex;
        align-items: flex-end;
        margin-right: 35px;
        padding: 0;
    }
}

.WInputSelect {
    position: relative;
    display: flex;
    align-items: flex-end;

    &:before {
        content: '';
        position: absolute;
        bottom: 0;
        height: 1px;
        width: 100%;
        margin-bottom: 15px;
        z-index: 999;
    }

    &.error {
        &:before {background: $danger;}
    }

    &::v-deep input:focus {
        border-bottom: $form-border;
    }

}

.WInput {
    &:after {
        content: '|';
        position: absolute;
        top: 5px;
        right: 0;
        color: $form-border;
    }
}

</style>
